module.exports = __webpack_public_path__ + "static/media/verificar identidad_b-01.a41f618d.svg";